/**
 * 차트 관련 타입 정의
 * @fileoverview 차트 레이아웃, 설정, 데이터 타입 및 상수 정의
 */
/**
 * TradingView 내장 지표 ID 배열
 * TradingView에서 제공하는 스터디(study) 이름을 그대로 사용합니다.
 * 타입 생성에만 사용되므로 내부 상수로 유지합니다.
 */
const CHART_INDICATOR_IDS = [
    'Average Price',
    'Directional Movement',
    'Moving Average Exponential',
    'Moving Average',
    'MACD',
    'TRIX',
    'Momentum',
    'Rate of Change',
    'Awesome Oscillator',
    'Commodity Channel Index',
    'Relative Strength Index',
    'Williams %R',
    'Bollinger Bands',
    'Parabolic SAR',
];
/**
 * 차트 기본값 상수
 */
export const CHART_DEFAULTS = {
    TIMEFRAME: '1',
    SYNC_COLOR: '#2962FF',
    GRID_COLUMNS: 1,
    GRID_ROWS: 1,
};
/**
 * 차트 시간대 옵션
 */
export const CHART_TIMEFRAMES = [
    { value: '1', label: '1m' },
    { value: '5', label: '5m' },
    { value: '15', label: '15m' },
    { value: '30', label: '30m' },
    { value: '60', label: '1h' },
    { value: '240', label: '4h' },
    { value: '1D', label: '1D' },
    { value: '1W', label: '1W' },
    { value: '1M', label: '1M' },
];
/**
 * 동기화 색상 옵션
 * Figma 디자인에 맞춰 색상 토큰 정의
 */
export const SYNC_COLORS = [
    { value: '--base-colors-blue-blue800-deep', label: 'A' },
    { value: '--trade-correct-background-solid', label: 'B' },
    { value: '--trade-cancel-background-solid', label: 'C' },
    { value: '--base-colors-primary-primary900', label: 'D' },
    { value: '--background-divider-muted', label: 'E' },
    { value: '--base-colors-red-red700', label: 'F' },
];
/**
 * 기본 주문 라인 스타일
 */
export const DEFAULT_ORDER_LINE_STYLE = {
    buyColor: '#ED2D32', // --button-red-border
    sellColor: '#0067EF', // --button-blue-border
    tpColor: '#00A22F', // --trade-correct-border
    slColor: '#DE8100', // --button-light-solid-text
};
//# sourceMappingURL=chart.js.map